import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, SparklesIcon, TrendingUpIcon, BookOpenIcon, UsersIcon } from 'lucide-react';
export function WhatYouGetSection() {
  const features = [{
    icon: CheckCircleIcon,
    title: 'Recetas Paso a Paso Con Cantidades EXACTAS',
    description: 'Obtienes recetas detalladas con instrucciones paso a paso, de la A a la Z, que hacen que crear jabones artesanales sea súper rápido, súper fácil y súper divertido. ¡Es como tener a una MAESTRA JABONERA a tu lado, guiándote en cada paso del proceso!'
  }, {
    icon: SparklesIcon,
    title: 'Lista de Materiales y Cantidades Precisas',
    description: 'Obtienes la lista EXACTA de materiales y cantidades para cada receta. Podrás comprar las cantidades justas, lo que significa que dejarás de desperdiciar tu dinero en materiales equivocados. Ahorra tiempo. Ahorra dinero. Ahorra frustración.'
  }, {
    icon: TrendingUpIcon,
    title: 'Método SECRETO de las Grandes Marcas',
    description: 'Conocerás el método que usan las grandes marcas de cosméticos para elaborar jabones artesanales de calidad premium... ahorrando hasta el 60% en materiales. Cuando las instrucciones son ESTE nivel de claras, tu jabón prácticamente SE HACE SOLO.'
  }, {
    icon: BookOpenIcon,
    title: 'Jabones Para TODOS Los Tipos de Piel',
    description: 'No solo aprendes recetas decorativas. Aprenderás a crear jabones terapéuticos y especializados: para piel grasa, sensible, seca, mixta y muchos más. Esto significa que podrás ofrecer jabones PERSONALIZADOS a tus clientes.'
  }, {
    icon: UsersIcon,
    title: 'Apto Para Principiantes Y Expertas',
    description: 'NO necesitas ser una química o tener equipos costosos. Ya sea que seas una principiante total, una entusiasta con herramientas básicas o una jabonera experimentada, encontrarás docenas de proyectos perfectos para tu nivel. ¡HAY ALGO PARA CADA UNA!'
  }];
  const soapTypes = ['Jabones aromáticos', 'Jabones para bautizos', 'Jabones para Navidad', 'Jabones tipo cupcake', 'Jabones con efecto mármol', 'Jabones de glicerina', 'Jabones de saponificación en frío', 'Jabones para piel grasa', 'Jabones para piel sensible', 'Jabones para piel seca', 'Jabones para piel mixta', 'Jabones exfoliantes', 'Jabones con hierbas naturales', 'Jabones decorativos', 'Jabones medicinales', 'Jabones con aceites esenciales', 'Jabones para bebé', 'Jabones para hombres', 'Jabones corporativos/recuerdos'];
  return <section className="w-full py-16 md:py-24 px-4 bg-cream" data-id="element-219">
      <div className="max-w-6xl mx-auto" data-id="element-220">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-221">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-brown mb-6" data-id="element-222">
            Presentamos...
          </h2>
          <div className="inline-block bg-gradient-to-r from-terracotta to-sage p-1 rounded-2xl mb-6" data-id="element-223">
            <div className="bg-cream px-8 py-6 rounded-xl" data-id="element-224">
              <p className="font-playfair text-3xl md:text-4xl font-bold text-terracotta mb-2" data-id="element-225">
                "Secretos de los Jabones"
              </p>
              <p className="font-inter text-xl text-brown/80" data-id="element-226">
                "¡La Guía Más Completa de Jabones Artesanales en Español!"
              </p>
            </div>
          </div>
          <p className="font-inter text-xl text-brown/90 max-w-3xl mx-auto leading-relaxed" data-id="element-227">
            Aprende a Elaborar +50 Tipos de Jabones Artesanales Profesionales
            Con Recetas Paso a Paso...
            <span className="font-bold text-terracotta" data-id="element-228">
              {' '}
              ...¡incluso si nunca has hecho un jabón en tu vida y tienes CERO
              experiencia!
            </span>
          </p>
        </motion.div>

        {/* What Makes It Better */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mb-16 text-center" data-id="element-229">
          <h3 className="font-playfair text-3xl md:text-4xl font-bold text-brown mb-6" data-id="element-230">
            ¿Qué hace que este libro sea 10 VECES MEJOR que cualquier otro
            recurso?
          </h3>
          <p className="font-inter text-lg text-brown/90 max-w-3xl mx-auto leading-relaxed" data-id="element-231">
            Simplemente: es lo suficientemente detallado para no dejar NADA a la
            imaginación, pero lo suficientemente simple para que una
            principiante completa lo entienda. Además, incluye instrucciones
            completas de inicio a fin.
          </p>
        </motion.div>

        {/* Features Grid */}
        <div className="space-y-8 mb-16" data-id="element-232">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -30 : 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-8 bg-white p-8 rounded-xl shadow-lg border-2 border-sage/20`} data-id="element-233">
              <div className="flex-shrink-0" data-id="element-234">
                <div className="w-20 h-20 bg-gradient-to-br from-terracotta to-sage rounded-full flex items-center justify-center" data-id="element-235">
                  <feature.icon className="w-10 h-10 text-white" data-id="element-236" />
                </div>
              </div>
              <div className="flex-1" data-id="element-237">
                <h4 className="font-playfair text-2xl font-bold text-brown mb-3" data-id="element-238">
                  Característica #{index + 1}: {feature.title}
                </h4>
                <p className="font-inter text-base text-brown/80 leading-relaxed" data-id="element-239">
                  {feature.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Soap Types */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-gradient-to-br from-terracotta/10 to-sage/10 p-8 md:p-12 rounded-2xl border-2 border-terracotta/30" data-id="element-240">
          <h3 className="font-playfair text-3xl md:text-4xl font-bold text-brown mb-8 text-center" data-id="element-241">
            Tipos de Jabones Que Puedes Crear HOY
          </h3>
          <p className="font-inter text-lg text-brown/80 mb-8 text-center" data-id="element-242">
            Solo una pequeña muestra de los tipos de jabones que aprenderás a
            elaborar:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-243">
            {soapTypes.map((type, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className="flex items-center gap-2 bg-white p-3 rounded-lg" data-id="element-244">
                <CheckCircleIcon className="w-5 h-5 text-sage flex-shrink-0" data-id="element-245" />
                <span className="font-inter text-sm text-brown/90" data-id="element-246">{type}</span>
              </motion.div>)}
            <div className="flex items-center gap-2 bg-white p-3 rounded-lg font-bold" data-id="element-247">
              <SparklesIcon className="w-5 h-5 text-gold flex-shrink-0" data-id="element-248" />
              <span className="font-inter text-sm text-brown" data-id="element-249">
                ¡Y MUCHOS MÁS!
              </span>
            </div>
          </div>

          <div className="mt-8 text-center" data-id="element-250">
            <p className="font-montserrat font-bold text-xl text-brown" data-id="element-251">
              50+ Recetas Detalladas • 2,500+ Alumnas Satisfechas • 7 Días Para
              Tu Primer Negocio
            </p>
          </div>
        </motion.div>

        {/* Final Promise */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-16 text-center bg-white p-8 rounded-xl shadow-lg" data-id="element-252">
          <h3 className="font-playfair text-3xl md:text-4xl font-bold text-terracotta mb-6" data-id="element-253">
            Recetas Tan Detalladas... ¡Que El Jabón Prácticamente Se Hace Solo!
          </h3>
          <p className="font-inter text-lg text-brown/90 leading-relaxed max-w-3xl mx-auto" data-id="element-254">
            "Secretos de los Jabones" te da el "paquete completo" de
            instrucciones y recursos para empoderarte a hacer esos jabones bien
            DESDE LA PRIMERA VEZ... y evitar todos los errores y la confusión.
          </p>
        </motion.div>
      </div>
    </section>;
}